import React, { useState, useEffect } from 'react';
import { Form, useFormikContext } from 'formik';
import { useFormikWizard } from 'formik-wizard';
import './CustomerDetails.css';
import * as Yup from 'yup';
import CommonInput from '../../../../components/Dashboard-res/CommonComponent/CommonInput.js';
import RadioButton from '../../../../components/Dashboard-res/CommonComponent/RadioButton.js';
import SelectProduct from './SelectProduct';
import Comments from './Commments';
import { validate as validatePhoneNumber } from '../../../../components/PhoneNumberValidation/PhoneNumberValidation';
import Loader from '../../../../common/components/CircularLoading/CircularLoading';
import { getPhoneNumberExist } from '../../../../common/constants/api';
import { console } from 'window-or-global';

const CustomerDetails = props => {
  const {
    values,
    parent,
    errors,
    touched,
    handleChange,
    handleBlur,
    isSubmitting,
    setFieldValue,
    setFieldTouched,
    setFieldError
  } = useFormikContext();
  const { values: wizardValues, setStatus, status } = useFormikWizard();
  const inputLength = values.mobile.length;
  const [Loaded, setLoaded] = useState(false);
  const [numberExist, setNumberExist] = useState(false);
  const { isMobileEdit = true } = wizardValues.CustomerDetails;

  function onEnquiryStatus(e) {
    if (e.target.value === 'Interested') {
      setFieldValue('EnquiryStatus', 'NEW_LEAD_ADDED');
    } else if (e.target.value === 'Not_Interested') {
      setFieldValue('EnquiryStatus', 'NOT_INTERESTED');
    } else if (e.target.value === 'Follow_Up') {
      setFieldValue('EnquiryStatus', 'FOLLOW_UP');
    }
  }
  const checkPhoneNumber = phone => {
    if (values.mobile.length == 10) {
      getPhoneNumberExist(phone).then(res => {
        if (res === true) {
          setNumberExist(true);
        } else if (res === false) {
          setNumberExist(false);
        }
      });
    }
  };
  return (
    <div onLoad={Loaded ? null : setLoaded(true)}>
      {Loaded ? (
        <div>
          <h1 className="text-center text-2xl py-4 font-khand text-xl font-semibold">
            Customer Details
          </h1>
          <React.Fragment>
            <div className=" m-2 md:mx-auto p-8 py-10 md:p-8 customer_container_box bg-white shadow-lg rounded-lg">
              <div className="name_field ">
                <div className="grid_input_container mb-10">
                  <div>
                    <CommonInput
                      name="Name"
                      id="Name"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.Name}
                      stylesContainer={{
                        height: '52px',
                        maxWidth: '100%'
                      }}
                      legendName="Customer First Name"
                      error={touched.Name && errors.Name}
                      errorMsg={errors.Name}
                      touched={touched.Name}
                    />
                  </div>
                </div>
              </div>
              <div className="name_field ">
                <div className="grid_input_container mb-8">
                  <div>
                    <CommonInput
                      name="lastName"
                      id="lastName"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.lastName}
                      stylesContainer={{
                        height: '52px',
                        maxWidth: '100%'
                      }}
                      error={touched.lastName && errors.lastName}
                      errorMsg={errors.lastName}
                      legendName="Customer Last Name"
                      touched={touched.lastName}
                    />
                  </div>
                </div>
              </div>

              <div className="mobile_field ">
                <div className="grid_input_container relative mb-4 mb-8">
                  <div
                    style={{ marginTop: '17px' }}
                    className="absolute text-grey-50 z-10 font-normal text-sm pt-px text-md ml-4"
                  >
                    +91
                  </div>
                  <div>
                    <CommonInput
                      name="mobile"
                      id="mobile"
                      disabled={!isMobileEdit}
                      maxLength={10}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.mobile}
                      stylesContainer={{
                        height: '52px',
                        maxWidth: '100%'
                      }}
                      inputStyle={{
                        paddingLeft: '45px',
                        letterSpacing: '1px'
                      }}
                      onBlurStyle={{
                        paddingLeft: '20px'
                      }}
                      legendStyle={{
                        paddingLeft: errors.mobile ? '20px' : '20px'
                      }}
                      legendName="Mobile Number"
                      error={touched.mobile && errors.mobile}
                      className={`pt-24`}
                      touched={touched.mobile}
                      errorMsg={errors.mobile}
                      onKeyPress={e => {
                        validatePhoneNumber(e, inputLength);
                      }}
                      onKeyUp={
                        isMobileEdit ? checkPhoneNumber(values.mobile) : null
                      }
                    />
                    {numberExist ? (
                      <p className="mt-1 text-xs text-red-300 mt-5">
                        Phone Number already exist.
                      </p>
                    ) : null}
                  </div>
                </div>
              </div>

              <div className="enquiry_status">
                <h2>Enquiry Status</h2>
                <div className="mb-10">
                  <div className="row-auto flex mb-6 mt-6">
                    <RadioButton
                      name="EnquiryStatus"
                      id="interested"
                      value="Interested"
                      checked={values.EnquiryStatus === 'NEW_LEAD_ADDED'}
                      onChange={e => {
                        handleChange(e);
                        onEnquiryStatus(e);
                        //setFieldValue('EnquiryStatus',true)
                      }}
                      onBlur={e => {
                        handleBlur(e);
                      }}
                    />
                    <label
                      htmlFor="Home Loan"
                      className="text-black-400 text-md text-right mt-0 ml-4"
                    >
                      Interested
                    </label>
                  </div>
                  <div className="row-auto	flex mb-6 mt-4">
                    <RadioButton
                      name="EnquiryStatus"
                      id="followup"
                      value="Follow_Up"
                      checked={values.EnquiryStatus === 'FOLLOW_UP'}
                      onChange={e => {
                        handleChange(e);
                        onEnquiryStatus(e);
                      }}
                      onBlur={e => {
                        handleBlur(e);
                      }}
                    />
                    <label
                      htmlFor="Home Loan"
                      className="text-black-400 text-md text-right mt-0 ml-4"
                    >
                      Follow Up
                    </label>
                  </div>

                  <div className="row-auto	flex mb-6 mt-4">
                    <RadioButton
                      name="EnquiryStatus"
                      id="notinterested"
                      value="Not_Interested"
                      checked={values.EnquiryStatus === 'NOT_INTERESTED'}
                      onChange={e => {
                        handleChange(e);
                        onEnquiryStatus(e);
                      }}
                      onBlur={e => {
                        handleBlur(e);
                      }}
                    />
                    <label
                      htmlFor="Home Loan"
                      className="text-black-400 text-md text-right mt-0 ml-4"
                    >
                      Not Interested
                    </label>
                  </div>
                  <div className="text-red-300 text-sm">
                    {touched.EnquiryStatus ? errors.EnquiryStatus : null}
                  </div>
                </div>
              </div>
              {values.EnquiryStatus == 'NEW_LEAD_ADDED' ? (
                <SelectProduct />
              ) : null}
              {values.EnquiryStatus == 'FOLLOW_UP' ? <Comments /> : null}
              {values.EnquiryStatus == 'NOT_INTERESTED' ? <Comments /> : null}
            </div>

            <div className="my-10 ">
              <button
                className="submitButton w-56
                     lg:w-80 "
                type="submit"
                id="submit"
                disabled={
                  errors.lastName ||
                  errors.Name ||
                  errors.mobile ||
                  errors.email ||
                  errors.EnquiryStatus ||
                  values.lastName == '' ||
                  values.Name == '' ||
                  values.mobile == '' ||
                  values.EnquiryStatus == '' ||
                  (values.EnquiryStatus == 'NEW_LEAD_ADDED'
                    ? values.loanamount == '' ||
                      errors.loanamount ||
                      values.pincode == '' ||
                      errors.pincode ||
                      errors.gender ||
                      values.gender == '' ||
                      errors.month == '' ||
                      errors.year == '' ||
                      errors.date == '' ||
                      values.date.value == '' ||
                      values.month.value == '' ||
                      values.year.value == ''
                    : false) ||
                  isSubmitting ||
                  numberExist === true
                }
              >
                Next
              </button>
              <div className="mt-2 block text-red-200 text-center">
                {status?.message}
              </div>
            </div>
          </React.Fragment>
        </div>
      ) : (
        <Loader />
      )}
    </div>
  );
};

export default CustomerDetails;
